import {Injectable,OnInit} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {AlertsService} from './alerts.service';
import {Router} from '@angular/router';
import {
  GET_CLIENT_CONFIG,
  WHATSAPP_SEND_TOKEN
} from '../../config';
import {DataService} from './data.service';
import * as moment from 'moment';
import { time } from 'highcharts';
import { ApiService } from './api.service';

@Injectable()
export class DatePickerService {

  private utcOffset = '+5.30';
  public today = moment().utc();
  // //console.log(today)

  constructor(private http: HttpClient,
              private alertsService: AlertsService,
              private router: Router, private dataservice : DataService,
              private apiService: ApiService ) {
                // this.apiService.whatapp_get(GET_CLIENT_CONFIG).subscribe(resp => {
                //   //console.log(resp,'++++++ cleient config +++++++')
                //   if(resp && resp['data'] && resp['data']['utcs'] ){
                //       this.utcOffset = resp['data']['utcs']
                //       // this.utcOffset = '-18.30'

                //   }
                // })


  }



  returnRanges( ranges,utcOffset = '+5.30' ) {

    // if(parseInt(utcOffset) > 0){

    // }else{

    // }
    this.utcOffset = utcOffset;
    let datePickerMap = {};
    var currentTime = new Date();
    //console.log(ranges,this.utcOffset,'__________________inside return ranges________________')
    //console.log( "return Ranges ", ranges );
    // //console.log( " currentTime ", currentTime );
    //console.log("UTCCC1",moment().utc().format("YYYY-MM-DD HH:mm:ss"));
    //console.log("IST OFFSET ",moment().add(this.utcOffset, 'hours').format("YYYY-MM-DD HH:mm:ss"));
    //console.log("UTC OFFSET",moment().utc().add(this.utcOffset, 'hours').format("YYYY-MM-DD HH:mm:ss"));

    // this.utcOffset
    //console.log("Today", moment().add(this.utcOffset, 'hours').utc() );
    // //console.log( " Yesterday ", moment().add(this.utcOffset, 'hours').subtract(1, 'days') );

    //moment().parseZone("")

    if( ranges.length > 0 ){

      //let today = moment();


      // if( this.utcOffset == '+5.30' ){   // For Indian
      //   this.utcOffset = '';
      // }
      //console.log(this.utcOffset,'utc-offset')
      ranges.forEach( range => {

          if( range == 'Today' ){
            datePickerMap['Today'] = [ moment().add("-5.30", 'hours').add(this.utcOffset, 'hours'), moment().add("-5.30", 'hours').add(this.utcOffset, 'hours') ];
          }
          else if( range == 'Yesterday' ){
            datePickerMap['Yesterday'] = [ moment().add("-5.30", 'hours').add(this.utcOffset, 'hours').subtract(1, 'days'), moment().add("-5.30", 'hours').add(this.utcOffset, 'hours').subtract(1, 'days') ];
          }
          else if( range == 'Last 7 days' ){
            datePickerMap['Last 7 days'] = [ moment().add("-5.30", 'hours').add(this.utcOffset, 'hours').subtract(7, 'days'), moment().add("-5.30", 'hours').add(this.utcOffset, 'hours') ];
          } 
          else if (range === 'This month'){
            datePickerMap['This month'] = [ moment().add("-5.30", 'hours').add(this.utcOffset, 'hours').startOf('month'), moment().add("-5.30", 'hours').add(this.utcOffset, 'hours') ];
          }
          else if( range == 'Last 30 days' ){
            datePickerMap['Last 30 days'] = [ moment().add("-5.30", 'hours').add(this.utcOffset, 'hours').subtract(30, 'days'), moment().add("-5.30", 'hours').add(this.utcOffset, 'hours') ];
          }
          else if( range == 'Last 90 days' ){
            datePickerMap['Last 90 days'] = [ moment().add("-5.30", 'hours').add(this.utcOffset, 'hours').subtract(90, 'days'), moment().add("-5.30", 'hours').add(this.utcOffset, 'hours') ];
          }
          else if( range == 'Last 3 months' ){
            datePickerMap['Last 3 months'] = [ moment().add("-5.30", 'hours').add(this.utcOffset, 'hours').subtract(3, 'month'), moment().add("-5.30", 'hours').add(this.utcOffset, 'hours') ];
          }
          else if( range == 'Last 6 months' ){
            datePickerMap['Last 6 months'] = [ moment().add("-5.30", 'hours').add(this.utcOffset, 'hours').subtract(6, 'month'), moment().add("-5.30", 'hours').add(this.utcOffset, 'hours') ];
          }
          else if( range == 'Last 12 months' ){
            datePickerMap['Last 12 months'] = [ moment().add("-5.30", 'hours').add(this.utcOffset, 'hours').subtract(12, 'month'), moment().add("-5.30", 'hours').add(this.utcOffset, 'hours') ];
          }

      });

    }
    // let ranges = [  'Last 30 days', 'Last 90 days','Last 3 months','Last 6 months','Last 12 months' ];
    //console.log(datePickerMap,"DATERANGE")

    return datePickerMap;

  }

  getRangesWithoutUTCOffset(ranges) {
    let datePickerMap = {};
    const today = moment();
    if (ranges.length > 0) {
      ranges.forEach(range => {
        if (range === 'Today') {
          datePickerMap['Today'] = [today, today];
        } else if (range === 'Yesterday') {
          datePickerMap['Yesterday'] = [moment().subtract(1, 'day'), moment().subtract(1, 'day')];
        } else if (range === 'Last 7 days') {
          datePickerMap['Last 7 days'] = [moment().subtract(7, 'days'), today];
        } else if (range === 'This month') {
          datePickerMap['This month'] = [moment().startOf('month'), today];
        } else if (range === 'Last 30 days') {
          datePickerMap['Last 30 days'] = [moment().subtract(30, 'days'), today];
        } else if (range === 'Last 90 days') {
          datePickerMap['Last 90 days'] = [moment().subtract(90, 'days'), today];
        } else if (range === 'Last 3 months') {
          datePickerMap['Last 3 months'] = [moment().subtract(3, 'month'), today];
        } else if (range === 'Last 6 months') {
          datePickerMap['Last 6 months'] = [moment().subtract(6, 'month'), today];
        } else if (range === 'Last 12 months') {
          datePickerMap['Last 12 months'] = [moment().subtract(12, 'month'), today];
        }
      });
    }
    return datePickerMap;
  }
}
